const $$splitComponentImporter = () => import('/home/runner/work/graph-it/graph-it/apps/graphit/src/routes/_authed/relationships/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { typesQueryOptions, typesStatsQueryOptions } from '~/queries/types';
import { workspacesQueryOptions } from '~/queries/workspaces';
export const Route = createFileRoute('/_authed/relationships')({
  loader: async ({
    context
  }) => {
    const workspaces = await context.queryClient.ensureQueryData(workspacesQueryOptions);
    const ids = workspaces.map(w => w.id);
    await Promise.all([context.queryClient.ensureQueryData(typesQueryOptions), context.queryClient.ensureQueryData(typesStatsQueryOptions(ids, ids))]);
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface RelationshipsHeaderProps {
  setShowImportRelationshipsModal: (show: boolean) => void;
}
interface RelationshipsSidebarProps {
  workspaces: Workspace[];
  isSidebarShrinked: boolean;
  setIsSidebarShrinked: (shrinked: boolean) => void;
}